import { Component, Input, OnInit } from '@angular/core';
import { HighlightPropertyModel } from 'src/app/models/highlights-property.model';
import { LoadingService } from 'src/app/services/loading.service';
import { SavedPropertiesService } from 'src/app/services/saved-properties.service';
import { UtilsPropertiesService } from 'src/app/services/utils-properties.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mobile-popular-properties',
  templateUrl: './mobile-popular-properties.component.html',
  styleUrls: ['./mobile-popular-properties.component.css']
})
export class MobilePopularPropertiesComponent implements OnInit {

  @Input() highlightsProperties!: any[];
  placeholder: boolean = false;
  imagesLoaded: boolean = false;

  constructor(
    public savedService: SavedPropertiesService,
    public utilsPropertiesService: UtilsPropertiesService,
    private loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.loadingService.placeholderValue.subscribe(value => {
      this.placeholder = value;
    });
  }

  imageError(evt: Event) {
    const el = evt.target as HTMLImageElement;
    el.src = 'assets/images/not-found.png';
  }

  saveProperty(reference: string) {
    this.savedService.saveProperty(reference);
  }

  imageLoad(i: any) {
    this.imagesLoaded = true;
  }

  priceFormat(propertyPrice: any, symbol: any = '€') {
    const spaces = (price: any) => String(price)
      .replace(
        /(?!^)(?=(?:\d{3})+$)/g,
        ' '
      );
    return symbol + ' ' + spaces(propertyPrice);
  }

}
